import { component } from "picoapp";
import { TablescapeState } from "../../state";

export const variantShippingNote = component((node: HTMLElement, context) => {
  context.on("tbsp:variant-selected", (variant) => {
    const { variantMetafields }: TablescapeState = context.getState();
    const shippingNote =
      variantMetafields[`${variant.id}`]?.accentuate.pdp_shipping_note;
    node.querySelector("[data-tbsp-component='text']").innerHTML = shippingNote;
  });
});
